import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.flat-map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, vShow as _vShow, toHandlers as _toHandlers, mergeProps as _mergeProps, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, isRef as _isRef } from "vue";
var _hoisted_1 = {
  class: "footer-left"
};
var _hoisted_2 = {
  class: "footer-right"
};
import global from '../../component-create/utils/global';
import { GLOBAL_DATA } from '../../component-create/utils/global-enum';
import UploadContainer from './UploadContainer.vue';

import { ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'XDataImport',
  props: {
    action: {
      type: String,
      required: true
    },
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    title: {
      type: String,
      default: '导入'
    },
    width: {
      type: String,
      default: '30%'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    autoUpload: {
      type: Boolean,
      default: false
    },
    accept: {
      type: Array,
      default: function _default() {
        return ['.xls', '.xlsx'];
      }
    },
    limit: {
      type: Number,
      default: 1
    },
    maxSize: {
      type: Number,
      default: 1024 * 1024 * 100
    },
    templateUrl: {
      type: String,
      default: ''
    },
    resultHandler: Function,
    errorHandler: Function,
    exportBaseUrl: {
      type: String,
      default: ''
    },
    beforeUpload: Function
  },
  emits: ['importStart', 'importEnd', 'importSuccess', 'importError'],
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose,
      __emit = _ref.emit;
    var DOWNLOAD = global.globalVal[GLOBAL_DATA.FILE_DOWNLOAD];
    var props = __props;
    var emits = __emit;
    var uploaderContainer = ref();
    var importing = ref(false);
    var template = ref({
      downloading: false
    });
    var result = ref({
      ready: false,
      message: ''
    });
    var diaVisible = ref(false);
    function show() {
      diaVisible.value = true;
    }
    function close() {
      diaVisible.value = false;
    }
    function reset() {
      var _uploaderContainer$va;
      importing.value = false;
      template.value.downloading = false;
      result.value.ready = false;
      result.value.message = '';
      (_uploaderContainer$va = uploaderContainer.value) === null || _uploaderContainer$va === void 0 || _uploaderContainer$va.reset();
    }
    function handleImport() {
      var _uploaderContainer$va2;
      (_uploaderContainer$va2 = uploaderContainer.value) === null || _uploaderContainer$va2 === void 0 || _uploaderContainer$va2.submit();
    }
    function handleClose() {
      close();
    }
    function handleClosed() {
      reset();
    }
    function handleImportStart() {
      importing.value = true;
      emits('importStart');
    }
    function handleImportEnd() {
      importing.value = false;
      emits('importEnd');
    }
    function handImportError(e) {
      emits('importError', e);
    }
    function handleImportSuccess(res) {
      var sheetImportResults = res.sheetImportResults;
      if (sheetImportResults && sheetImportResults.length > 0) {
        result.value.message = sheetImportResults.flatMap(function (r) {
          return r.sheetName + '：' + r.importCount + '条';
        }).join('，');
        result.value.ready = true;
      }
      emits('importSuccess', res);
    }
    function handleDownloadTemplate() {
      downloadTemplate();
    }
    function downloadTemplate() {
      if (template.value.downloading) {
        return;
      }
      var promise = DOWNLOAD("".concat(props.exportBaseUrl, "/template/").concat(encodeURIComponent(props.templateUrl)), {});
      template.value.downloading = true;
      if (promise) {
        promise.finally(function () {
          template.value.downloading = false;
        });
      }
    }
    __expose({
      show: show
    });
    return function (_ctx, _cache) {
      var _component_el_button = _resolveComponent("el-button");
      var _component_el_result = _resolveComponent("el-result");
      var _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(diaVisible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(diaVisible) ? diaVisible.value = $event : null;
        }),
        title: __props.title,
        width: __props.width,
        closeable: !_unref(importing),
        onClose: handleClosed
      }, {
        footer: _withCtx(function () {
          return [_renderSlot(_ctx.$slots, "footer"), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_1, [__props.templateUrl ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            size: "small",
            type: "primary",
            plain: "",
            round: "",
            loading: _unref(template).downloading,
            onClick: handleDownloadTemplate
          }, {
            default: _withCtx(function () {
              return _cache[2] || (_cache[2] = [_createTextVNode("下载模板文件 ")]);
            }),
            _: 1
          }, 8, ["loading"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
            onClick: handleClose
          }, {
            default: _withCtx(function () {
              return _cache[3] || (_cache[3] = [_createTextVNode("取消")]);
            }),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            loading: _unref(importing),
            onClick: handleImport
          }, {
            default: _withCtx(function () {
              return _cache[4] || (_cache[4] = [_createTextVNode("导入")]);
            }),
            _: 1
          }, 8, ["loading"])])])];
        }),
        default: _withCtx(function () {
          return [_renderSlot(_ctx.$slots, "custom"), _withDirectives(_createVNode(UploadContainer, _mergeProps({
            ref_key: "uploaderContainer",
            ref: uploaderContainer
          }, _ctx.$props, {
            onImportSuccess: handleImportSuccess,
            onImportStart: handleImportStart,
            onImportEnd: handleImportEnd,
            onImportError: handImportError,
            exportBaseUrl: __props.exportBaseUrl
          }, _toHandlers(_ctx.$attrs)), null, 16, ["exportBaseUrl"]), [[_vShow, !_unref(result).ready]]), _withDirectives(_createVNode(_component_el_result, {
            icon: "success",
            title: "导入成功"
          }, {
            "sub-title": _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_unref(result).message), 1)];
            }),
            extra: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                type: "primary",
                onClick: close
              }, {
                default: _withCtx(function () {
                  return _cache[1] || (_cache[1] = [_createTextVNode("确定")]);
                }),
                _: 1
              })];
            }),
            _: 1
          }, 512), [[_vShow, _unref(result).ready]])];
        }),
        _: 3
      }, 8, ["modelValue", "title", "width", "closeable"]);
    };
  }
});